





















import { Component, Mixins, Vue } from 'vue-property-decorator'
import SidebarSwitcher from '@/components/organisms/v2/SidebarSwitcher.vue'
import ColoredBox from '@/components/atoms/ColoredBox.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import StyleSubjectBackground from '@/components/atoms/StyleSubjectBackground.vue'
import AlignedWebApi from '@/mixins/drillsv3/AlignedWebApi'

@Component({
  components: {
    SidebarSwitcher,
    ColoredBox,
    ButtonBase,
  },
})
export default class AlignedSubjects extends Mixins(StyleSubjectBackground, AlignedWebApi) {
  public async mounted(): Promise<void> {
    Vue.prototype.$loading.start()
    await this.loadEnableSubjects()
    Vue.prototype.$loading.complete()
  }

  private subjectDatas: { text: string; code: string }[] = []

  /**
   * 教科選択
   */
  private async selectSubject(subjectId: string, subjectCode: string): Promise<any> {
    this.$router.push({
      path: '/student/aligned/l-units',
      query: {
        subjectId,
        subjectCode,
      },
    })
  }

  private async loadEnableSubjects() {
    const enableSubjects = await this.getAlignedActiveSubject()

    this.subjectDatas = enableSubjects.map((subject: any) => {
      return { text: subject.subjectName, code: subject.subjectCode, id: subject.subjectId }
    })
  }
}
